import React, { useState } from 'react';
import { Button, FormCheckbox, ModalFooter } from 'shards-react';
import { EDIT_ACTION } from '../../constants';

interface ModalEditFooterProps {
  mode: string;
  theme: string;
  disabled: boolean;
  isDeletable?: boolean;
  labelCancel: string;
  labelSave: string;
  labelCheckBox: string;
  deleteFlag: boolean;
  onCancel: () => void;
  onSave: () => void;
  onToggle: () => void;
}

const ModalEditFooter = ({ mode, theme, disabled, isDeletable = true, labelCancel, labelSave, labelCheckBox, deleteFlag, onCancel, onSave, onToggle }: ModalEditFooterProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalFooter>
      <Button theme="light" onClick={onCancel}>
        {labelCancel}
      </Button>
      {mode !== EDIT_ACTION.VIEW && (
        <Button theme={theme} disabled={disabled} onClick={onSave}>
          {labelSave}
        </Button>
      )}
      {isDeletable && mode === EDIT_ACTION.DELETE && (
        <FormCheckbox inline checked={deleteFlag} onChange={onToggle}>
          {labelCheckBox}
        </FormCheckbox>
      )}
    </ModalFooter>
  );
};

export default ModalEditFooter;
